<div class="wake-up-alarm-widget">
  <!-- LIST MODE -->
  <ng-container *ngIf="mode === 'list'">
    <div class="header">
      <div class="title">{{ 'WIDGETS.MARRIOTT_WAKE_UP_ALARM.TITLE' | translate }}</div>
      <div class="subtitle">{{ 'WIDGETS.MARRIOTT_WAKE_UP_ALARM.LIST_SUBTITLE' | translate }}</div>
    </div>

    <div class="content">
      <div class="alarms-container" *ngIf="alarms.length > 0">
        <div
          class="alarm-row"
          *ngFor="let alarm of alarms; let first = first; trackBy: trackByAlarmId"
          [attr.data-alarm-id]="alarm.id">
          <div class="alarm-info">
            <span class="alarm-time">{{ formatTime12h(alarm.time!) }}</span>
            <span class="alarm-date">{{ getAlarmDateDisplay(alarm) | translate }}</span>
          </div>
          <div class="alarm-actions">
            <button
              class="edit-button htv-selectable"
              [class.htv-focus-10]="first"
              (click)="enterEditMode(alarm)"
              (focus)="onAlarmFocus(alarm.id!)">
              {{ 'WIDGETS.MARRIOTT_WAKE_UP_ALARM.EDIT' | translate }}
            </button>
            <button
              class="delete-button htv-selectable"
              (click)="deleteAlarm(alarm.id!)"
              (focus)="onAlarmFocus(alarm.id!)">
              {{ 'WIDGETS.MARRIOTT_WAKE_UP_ALARM.DELETE' | translate }}
            </button>
          </div>
        </div>
      </div>

      <div class="no-alarms" *ngIf="alarms.length === 0">
        <p>{{ 'WIDGETS.MARRIOTT_WAKE_UP_ALARM.NO_ALARMS' | translate }}</p>
      </div>
    </div>

    <div class="instructions">
      <div class="instruction-line">{{ 'WIDGETS.MARRIOTT_WAKE_UP_ALARM.LIST_INSTRUCTION' | translate }}</div>
      <button
        class="alarm-button htv-selectable"
        *ngIf="canAddMoreAlarms"
        [class.htv-focus-10]="alarms.length === 0"
        (click)="enterEditMode()">
        {{ 'WIDGETS.MARRIOTT_WAKE_UP_ALARM.ADD_ALARM' | translate }}
      </button>
      <div class="max-alarms-message" *ngIf="!canAddMoreAlarms">
        {{ 'WIDGETS.MARRIOTT_WAKE_UP_ALARM.MAX_ALARMS_REACHED' | translate }}
      </div>
    </div>
  </ng-container>

  <!-- EDIT MODE -->
  <ng-container *ngIf="mode === 'edit'">
    <div class="header">
      <div class="title">{{ editTitle | translate }}</div>
      <div class="subtitle">{{ 'WIDGETS.MARRIOTT_WAKE_UP_ALARM.SUBTITLE' | translate }}</div>
    </div>

    <div class="time-display">
      <div class="time-digits">
        <div class="digit-box htv-selectable htv-force-direction htv-focus-10" (click)="onDigitClick(0)">
          <span class="digit">{{ digits[0] }}</span>
        </div>
        <div class="digit-box htv-selectable htv-force-direction" (click)="onDigitClick(1)">
          <span class="digit">{{ digits[1] }}</span>
        </div>

        <div class="separator">:</div>

        <div class="digit-box htv-selectable htv-force-direction" (click)="onDigitClick(2)">
          <span class="digit">{{ digits[2] }}</span>
        </div>
        <div class="digit-box htv-selectable htv-force-direction" (click)="onDigitClick(3)">
          <span class="digit">{{ digits[3] }}</span>
        </div>
      </div>

      <div class="am-pm-selector">
        <div class="am-button" [class.selected]="!isPM">
          <span class="indicator"></span>
          <span class="label">AM</span>
        </div>
        <div class="pm-button" [class.selected]="isPM">
          <span class="indicator"></span>
          <span class="label">PM</span>
        </div>
      </div>
    </div>

    <div class="instructions">
      <div class="instruction-line">{{ 'WIDGETS.MARRIOTT_WAKE_UP_ALARM.INSTRUCTION_1' | translate }}</div>
      <div class="instruction-line">
        {{ 'WIDGETS.MARRIOTT_WAKE_UP_ALARM.INSTRUCTION_2' | translate }} <span class="red-button"></span>
      </div>
      <button
        class="alarm-button htv-selectable"
        *ngIf="canSaveAlarm"
        [class.saving]="isSaving"
        [disabled]="isSaving"
        (click)="saveAlarm()">
        {{ saveButtonText | translate }}
      </button>
      <div class="max-alarms-message" *ngIf="!canSaveAlarm">
        {{ 'WIDGETS.MARRIOTT_WAKE_UP_ALARM.MAX_ALARMS_REACHED' | translate }}
      </div>
    </div>
  </ng-container>
</div>
